import FeatureGates, { type GetExperimentValueOptions } from '@atlaskit/feature-gate-js-client';

// copied from '@atlaskit/tmp-editor-statsig/expVal' to avoid circular dependency
export const expVal = (
	experimentName: string,
	experimentParam: string,
	defaultValue: boolean,
	options: GetExperimentValueOptions<boolean> = {},
): boolean => {
	// If client is not initialized, we return the default value
	if (!FeatureGates.initializeCompleted()) {
		return defaultValue;
	}

	// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
	const experimentValue = FeatureGates.getExperimentValue(
		experimentName,
		experimentParam,
		defaultValue,
		options,
	);

	return experimentValue;
};
